import { Dayjs } from "dayjs";
import { ICaseInformation } from "us.collection.case/reducers/CaseInformation/Interfaces";

export const disabledDate = (
  current: Dayjs,
  dateField: keyof ICaseInformation,
  dueDate: Dayjs | undefined,
) => {
  if (dueDate && dateField === "obsoleteDate"){
    return current && current < dueDate.endOf("day");
  }else{
      return false;
  }
    
};
